// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__8-KIB","header":"Footer_header__2aJlH","social-media-container":"Footer_social-media-container__2JSJ7"};